import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import ApiCaller from "api/apiCaller";
import "./index.scss";
import t from "utils/Lang";

const AssigmentManager = ({ assignees, contentType, contentId, users }) => {
  const selectRef = useRef(null);
  let defaultAssignees = [];
  if (assignees) {
    assignees.map((assignee) => {
      defaultAssignees.push({
        value: assignee.id,
        label: `${assignee.first_name} ${assignee.last_name}`,
      });
    });
  }
  const [isSelectDisabled, setIsSelectDisabled] = useState(true);
  const [currentAssignees, setCurrentAssignees] = useState(defaultAssignees);

  const updateAssigneeUsers = async () => {
    let bodyToSubmit = {};
    if (!currentAssignees || currentAssignees.length <= 0) {
      bodyToSubmit = {
        user_ids: [],
      };
    } else {
      bodyToSubmit = {
        user_ids: currentAssignees.map((currentAssignee) => {
          return currentAssignee.value;
        }),
      };
    }
    const res = await ApiCaller.post(
      `user_assignment/${contentType}/${contentId}`,
      bodyToSubmit
    );
    if (res.status === "ok") {
      setIsSelectDisabled(true);
    }
  };
  const selectUserAssigment = (selectedUsers) => {
    setCurrentAssignees(selectedUsers);
  };
  const toogleEditMode = () => {
    if (isSelectDisabled) {
      setIsSelectDisabled(false);
    } else {
      setIsSelectDisabled(true);
    }
  };
  const saveAssignees = () => {
    updateAssigneeUsers();
  };
  return (
    <div>
      <div style={styles.header}>
        <span className="assignee-title">{t().site_detail__assignment}</span>
        {!isSelectDisabled ? (
          <span style={styles.editFollowers} onClick={saveAssignees}>
            {t().action__save}
          </span>
        ) : (
          <span style={styles.editFollowers} onClick={toogleEditMode}>
            {t().action__edit}
          </span>
        )}
      </div>
      <Select
        isMulti
        isDisabled={isSelectDisabled}
        options={users}
        value={currentAssignees}
        onChange={(selectedUsers) => selectUserAssigment(selectedUsers)}
      />
    </div>
  );
};

const styles = {
  header: {
    marginBottom: 6,
  },
  editFollowers: {
    color: "var(--primary)",
    marginLeft: 12,
    cursor: "pointer",
  },
};

export default AssigmentManager;
